/**
 * ss-newsletter-v32.js — loading state on submit
 */
(function () {
  'use strict';
  function boot() {
    document.querySelectorAll('[data-ss-newsletter] form').forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[data-ss-nl-submit]');
        if (!btn) return;
        btn.classList.add('is-loading');
        var spin = btn.querySelector('.ss-club-cta__spin');
        if (spin) spin.hidden = false;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
